<template>
	<div id="app">
		<router-view></router-view>
		<FloatingSupport />
	</div>
</template>

<script>
	import Index from './views/index.vue'
	import FloatingSupport from './components/FloatingSupport.vue'
	export default {
		name: 'app',
		components: {
			Index,
			FloatingSupport
		},
		data() {
			return {
				pageTitle: 'MEOW',
				game: this.$store.state.gameData,
				hasLogin: this.$session.hasLogin()
			};
		},
		created() {
			this.handleAutoLoginFromUrl();
		},
		mounted() {
			this.updateTitle(this.game.gameName);
			this.updateFavicon(this.game.gameIcon);
		},
		methods: {
			handleAutoLoginFromUrl() {
				if(this.hasLogin) return;
				const params = new URLSearchParams(window.location.search);
				const userId = params.get('userId');
				// 兼容两种 token 字段：JWT 格式的 token 和 SDK 的 loginAccessToken
				const token = params.get('token') || params.get('loginAccessToken');
				if (!token || !userId) return;

				const loginData = {
					token,
					userId,
					loginId:        params.get('loginId') || '',
					loginToken:     params.get('loginToken') || params.get('loginAccessToken') || '',
					telephone:      params.get('telephone') === 'null' ? null : (params.get('telephone') || null),
					env:            params.get('env') || '',
					isBindAccount:  params.get('isBindAccount') === 'true',
					isBindPhone:    params.get('isBindPhone') === 'true',
					isTest:         params.get('isTest') === 'true',
					loginTimestamp: params.get('loginTimestamp') || '',
					timestamp:      params.get('timestamp') || String(Date.now()),
				};

				this.$session.setLoginDataToCookie(loginData);
				this.$cache.setLoginData(loginData);

				// 角色信息（URL 中有直接写入，跳过手动选角步骤）
				const roleId = params.get('roleId');
				const serverCode = params.get('serverCode');
				if (roleId && serverCode) {
					const roleObj = {
						serverCode,
						serverName:   params.get('serverName') || '',
						roleId,
						roleName:     params.get('roleName') || '',
						roleLevel:    params.get('roleLevel') || '',
						roleVipLevel: params.get('roleVipLevel') || '',
						roleAvatar:   params.get('roleAvatar') || '',
					};
					roleObj.object = Object.assign({}, roleObj);
					this.$cache.setRoleInfo(roleObj);
				}
			},
			updateTitle(newTitle = "") {
				if (newTitle) {
					this.pageTitle = newTitle;
				}
				document.title = this.pageTitle;
			},
			updateFavicon(newUrl = "") {
				if (newUrl) {
					this.faviconUrl = newUrl;
				}
				const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				link.type = 'image/x-icon';
				link.rel = 'shortcut icon';
				link.href = this.faviconUrl;
				if (!document.querySelector("link[rel*='icon']")) {
					document.getElementsByTagName('head')[0].appendChild(link);
				}
			}
		}
	}
</script>

<style>
	::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 8px;
		height: 8px;
	}

	::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.1);
		border-radius: 0;
	}

	::-webkit-scrollbar-thumb {
		cursor: pointer;
		border-radius: 5px;
		background: #659aff;
		transition: color 0.2s ease;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(0, 0, 0, 0.3);
	}
</style>
